"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResults = void 0;
const getResults = async (supabase, tableName, tableFields, tableFilter, tableOrder) => {
    const getFilterParam = (query, filter) => {
        switch (filter.type) {
            case "or":
                return query.or(filter.value);
            case "eq":
                return query.eq(filter.field, filter.value);
            case "neq":
                return query.neq(filter.field, filter.value);
            case "like":
                return query.like(filter.field, filter.value);
            case "contains":
                return query.contains(filter.field, filter.value);
        }
    };
    let query = supabase
        .from(tableName)
        .select(tableFields)
        .order(tableOrder, { ascending: true });
    if (tableFilter) {
        // for each filter, add a filter to the query
        tableFilter.forEach((filter) => {
            const filterQuery = getFilterParam(query, filter);
            if (filterQuery)
                query = filterQuery;
        });
    }
    const { data, error } = await query;
    if (!error)
        return data;
    return error;
};
exports.getResults = getResults;
